(function () {
    'use strict';

    angular.module('app.common', [
        /*
         * Angular modules
         */
        'ngAnimate', 'ui.router',

        /*
         * Our reusable cross app code modules
         */
        'MINT',
        // 'USSA',
        'user',
        'auth',
        'message',
        'tracking',
        'blocks.logger',
        'blocks.exception',
        'blocks.router',
        'blocks.cache',
        'pascalprecht.translate',
        'ngCookies',
        'emailVerification',
        'gdpr',
        'cpm',
        /*
         *  3d party modules
         */
        'monospaced.qrcode',
        'notificationInterpolate'
    ]);
})();
